<div class="exception-dialog">
  <header class="head">
    <h2 class="title" [id]="titleId">{{ $title() }}</h2>
    @if ($recorded()) {
      <p class="recorded">{{ $recorded() }}</p>
    }
  </header>

  @if ($readonly()) {
    @if ($exception(); as exception) {
      <div class="snapshot">
        <p class="reason-name">{{ exception.reason.name }}</p>
        @if (exception.comment) {
          <p class="copy">{{ exception.comment }}</p>
        }
      </div>
    }
  }

  @if ($explained().length) {
    <section class="evidence">
      <div class="explains">
        <span class="label">Explains</span>
        @for (name of $explained(); track name) {
          <w-badge [mode]="BadgeMode.Squared" size="small" [label]="name" />
        }
      </div>
      @for (note of $notes(); track note) {
        <p class="copy">{{ note }}</p>
      }
    </section>
  }

  @if (!$readonly()) {
    <div class="field">
      @if (!$noReasonFits()) {
        <span class="label">Reason</span>
      }
      @if ($reasonsFailed()) {
        <div class="error" role="alert">
          Reasons could not be loaded.
          <wb-button label="Retry" [size]="ButtonSize.Small" [displayStyle]="ButtonDisplayStyle.Secondary" (onClick)="retryReasons()" />
        </div>
      } @else if ($noReasonFits()) {
        <p class="copy empty">{{ $noReasonFits() }}</p>
      } @else {
        <wb-select [items]="$reasons()" bindLabel="name" bindValue="_id" [ngModel]="$selectedId()" (ngModelChange)="onReason($event)" [loading]="$reasonsLoading()" [clearable]="false" placeholder="Select a reason" />
      }
    </div>
  }

  @if (!$readonly() && !$reasonsFailed() && !$noReasonFits()) {
    <div class="field">
      <label class="label" [attr.for]="commentId">Comment (optional)</label>
      <textarea class="comment" [id]="commentId" rows="3" [value]="$comment()" (input)="onComment($event)" placeholder="Add a comment"></textarea>
    </div>
  }

  @if ($error(); as error) {
    <p class="error" role="alert">{{ error }}</p>
  }

  <footer class="actions">
    @if (!$readonly() && $exception()) {
      <wb-button class="remove" label="Remove exception" [size]="ButtonSize.Medium" [displayStyle]="ButtonDisplayStyle.Tertiary" [accent]="ButtonAccent.Danger" [disabled]="$busy()" (onClick)="remove()" />
    }
    <wb-button [label]="$readonly() ? 'Close' : 'Cancel'" [size]="ButtonSize.Medium" [disabled]="$busy()" (onClick)="cancel()" />
    @if (!$readonly()) {
      <wb-button label="Save" [size]="ButtonSize.Medium" [displayStyle]="ButtonDisplayStyle.Primary" [disabled]="!$canSave()" (onClick)="save()" />
    }
  </footer>
</div>
